import { useTranslation } from 'react-i18next';

import FormStepWrapper from 'components/form/FormStepWrapper';
import { useBecomeFundraiser } from 'features/my-profile/become-fundraiser/context/BecomeFundraiserProvider';
import HelpButton from 'features/my-profile/become-fundraiser/form/components/HelpButton';
import RoutingNumberInput from 'features/my-profile/become-fundraiser/form/components/routing-number/RoutingNumberInput';
import { useRoutingNumberHelpPopup } from 'features/my-profile/become-fundraiser/form/components/routing-number/useRoutingNumberHelpPopup';
import SkipButton from 'features/my-profile/become-fundraiser/form/components/SkipButton';

const VerifyRoutingNumber = () => {
  const { t } = useTranslation('myProfile');
  const { formData, errors, setFieldValue } = useBecomeFundraiser();
  const { showRoutingNumberHelpPopup } = useRoutingNumberHelpPopup();

  return (
    <FormStepWrapper
      header={t('become-fundraiser.verify-routing-number.header')}
      description={t('become-fundraiser.verify-routing-number.description')}
      isValid={!errors.routingNumber && !errors.bankName}>
      <RoutingNumberInput
        routingNumber={formData.routingNumber || ''}
        bankName={formData.bankName || ''}
        onRoutingNameChange={value => setFieldValue('routingNumber', value)}
        onBankNameChange={value => setFieldValue('bankName', value)}
        errorMessage={errors.routingNumber || errors.bankName}
      />
      <HelpButton onClick={showRoutingNumberHelpPopup} />
      <SkipButton />
    </FormStepWrapper>
  );
};

export default VerifyRoutingNumber;
